import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c3-three-one-one',
  templateUrl: './c3-three-one-one.component.html',
  styleUrls: ['./c3-three-one-one.component.scss']
})
export class C3ThreeOneOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
